export const getInviteLink = (uuid: string) =>
  `${process.env.HTTP_PROTOCOL}://app.${process.env.ROOT_NETLOC}/signup?invite_token=${uuid}`;
